import { render, staticRenderFns } from "./dispatcher_performance_report.vue?vue&type=template&id=66591e1c&"
import script from "./dispatcher_performance_report.vue?vue&type=script&lang=js&"
export * from "./dispatcher_performance_report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66591e1c')) {
      api.createRecord('66591e1c', component.options)
    } else {
      api.reload('66591e1c', component.options)
    }
    module.hot.accept("./dispatcher_performance_report.vue?vue&type=template&id=66591e1c&", function () {
      api.rerender('66591e1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/audit_logs/report/dispatcher_performance_report.vue"
export default component.exports